import { FAQPageJsonLd } from "next-seo";

import type { FaqItem } from "~landing/components/home/faqs";

/**
 * Emits FAQPage JSON-LD from a page's FAQ list. Drop it next to the `<Faqs>`
 * block on any page that renders one. Answers are plain strings already, so no
 * markup stripping is needed.
 */
export function FaqSchema({ faqs }: { faqs: FaqItem[] }) {
	if (faqs.length === 0) return null;

	return (
		<FAQPageJsonLd
			useAppDir={false}
			mainEntity={faqs.map((faq) => ({
				questionName: faq.question,
				acceptedAnswerText: faq.answer,
			}))}
		/>
	);
}
